// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"ee32d953","411":"2dcc56de"}[chunkId] + ".chunk.js";
};